import { React, useState, useEffect, useMemo, memo } from "react";
import { QuestionOutlined } from '@ant-design/icons';
import { Button, Popover, Collapse, Modal, Dropdown  } from 'antd';
import { Link } from "react-router-dom";
import '../../Styles/styles-misc.css';
import { useSelector } from "react-redux";
import { getMetricInfoByIdentifier } from "../../Utils/chart_utils";
import { MultiMetricChart } from "../MultMetricChart/MultiMetricChart.jsx";
import { StatChartV2 } from "../StatChartV2/StatChartV2.jsx";
// import { GPSChartWithSelect } from "./GPSChartWithSelect.jsx";
import { WellnessChartWithSelect } from "./WellnessChartWithSelect.jsx";

export const ChartWithSelect = memo(({ 
	chartIndex, 
	selectedMetricKey, 
	handleChartDropdownChange, 
	stat, 
	startDate, 
	endDate,
	playerGroup,
	position
 }) => {
    const {
		dropdowns: {player: playerDropdowns},
		info: {display_name: teamName, team_colors: teamColors, restAndTravel, custom_charts: customChartData,
			acwr_threshold_config: acwrThresholdConfig, metric: teamMetric
		},
		all_metric_types
	} = useSelector(({ team }) => team);

	const {
		filter: { player: filterPlayer },
	} = useSelector((store) => store['player']);

	const [title, setTitle] = useState();
	const [chartMetric, setChartMetric] = useState();
    const chartByChartType = useMemo(() => {
		if (!chartMetric || !selectedMetricKey) {
			return (<></>);
		}
		
		if (selectedMetricKey?.startsWith("forceplate")) {
			return (<StatChartV2
				value={selectedMetricKey}
				metricType="forceplate"
				startDate={startDate.format("YYYY-MM-DD")}
				endDate={endDate.format("YYYY-MM-DD")}
				playerId={filterPlayer}
				stat={stat}
				position={position}
				colors={teamColors.all}
				player_group={playerGroup}
				sessions={[]}
				showTitle={false}
			/>);
			
		} else if (selectedMetricKey?.startsWith("testing")) {
			return (<StatChartV2
				value={selectedMetricKey}
				metricType="testing"
				startDate={startDate.format("YYYY-MM-DD")}
				endDate={endDate.format("YYYY-MM-DD")}
				playerId={filterPlayer}
				stat={stat}
				position={position}
				colors={teamColors.all}
				player_group={playerGroup}
				sessions={[]}
				showTitle={false}
			/>);
		} else if (selectedMetricKey?.startsWith("nutrition")) {
			return (<MultiMetricChart
				values={[selectedMetricKey]}
				metricType="nutrition"
				startDate={startDate}
				endDate={endDate}
				playerId={player}
				stat={stat}
				position={position}
				player_group={playerGroup}
				showTitle={false}
				showDataLabelToggle={false}
				chartIndex={chartIndex}
				pageType="profile"
			/>);
		} else if (selectedMetricKey?.startsWith("cognition")) {
			return (<MultiMetricChart
				values={[selectedMetricKey]}
				metricType="cognition"
				startDate={startDate}
				endDate={endDate}
				playerId={player}
				stat={stat}
				position={position}
				player_group={playerGroup}
				showTitle={false}
				showDataLabelToggle={false}
				chartIndex={chartIndex}
				pageType="profile"
			/>);
		} else {

			return (<WellnessChartWithSelect
				pageType={'team'}
				wellnessMetric={chartMetric}
				startDate={startDate}
				endDate={endDate}
				showBodyMap={false}
			/>);
		}
    }, [chartMetric, playerGroup, position])

	useEffect(() => {
		let [chartTitle, chartMetric] = getMetricInfoByIdentifier(selectedMetricKey, all_metric_types);
		setTitle(chartTitle);
		setChartMetric(chartMetric);
	}, [selectedMetricKey])

    return (
        <>
           <div className="overview-v2-chart">
				<div>
					<Dropdown
						menu={{
							items: playerDropdowns || [],
							onClick: handleChartDropdownChange(chartIndex),
						}}
						trigger={["hover"]}
						style={{
							width: '100%',
						}}
					>
						<Link>
						<Button
							style={{
							fontSize: 16,
							height: "32px",
							whiteSpace: "nowrap",
							maxWidth: 310,
							textAlign: "center",
							align: 'center',
							overflow: "hidden",
							border: '1px solid #cccccc'
							}}
							size="small"
							type="text"
						>
							<div className={title?.length > 33 ? "chartLabelContainer": 'none'}> 
								<span><h4>{title}</h4></span>
							</div>

						</Button>
						</Link>
					</Dropdown>
				</div>
				<div className="select-chart-container">
					{chartByChartType}
				</div>
		   </div>
        </>
    );
});

export default ChartWithSelect;